import { Box } from '@customink/pigment-react';
import type { ElementType, PropsWithChildren, ReactNode } from 'react';
import { Fragment } from 'react';

import { Delimiter as DelimiterElement } from './Delimiter';

type DelimitedSetProps = {
  Delimiter?: ElementType;
  elements?: ReactNode[];
  isLoading?: boolean;
};

export const DelimitedSet = ({
  elements,
  Delimiter = DelimiterElement,
}: PropsWithChildren<DelimitedSetProps>) => {
  if (!elements?.length) return null;

  const contentfulElements = elements.filter((element) => !!element);

  return (
    <Box display="flex" flex="row" flexWrap="wrap">
      {contentfulElements.map((child, i) => (
        <Fragment key={i}>
          {child}
          {i < contentfulElements.length - 1 && <Delimiter />}
        </Fragment>
      ))}
    </Box>
  );
};
